module.exports = __webpack_public_path__ + "3280b0d19746971ae0a452256fa86c0c.png";